const { useI18n } = require('nordic/i18n');
const { CardContent, CardSecondary } = require('@andes/card');
const { Button } = require('@andes/button');
const { Typography } = require('@andes/typography');
const className = require('classnames');

const { generateIcon } = require('../../../utils/icons');
const translate = require('../../../translation');

const UserAddressCard = ({ isMobile, handleAction, title, address }) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);

  const actionButton = () =>
    isMobile ? (
      <div onClick={handleAction}>
        <Typography type="body" color="link" weight="semibold">
          {translations.MODIFY}
        </Typography>
      </div>
    ) : (
      <Button
        hierarchy="transparent"
        size="medium"
        type="button"
        onClick={handleAction}
      >
        {translations.MODIFY}
      </Button>
    );

  return (
    <CardSecondary paddingSize={16}>
      <CardContent className="d-flex address-user-card g-8">
        <div className={className('pin-icon', { 'd-flex': !isMobile })}>
          {generateIcon({ type: 'icon_pin' })}
        </div>

        <section
          className={`d-flex-one d-flex g-8 ${isMobile && 'd-flex-column'} ${
            !isMobile && 'align-items-center'
          }`}
        >
          <div className="d-flex-one d-flex d-flex-column g-8">
            {title && (
              <Typography size="s" type="body" weight="semibold">
                {title}
              </Typography>
            )}

            {address && (
              <Typography size="s" type="body" weight="regular" color="primary">
                {address}
              </Typography>
            )}
          </div>

          {handleAction ? actionButton() : undefined}
        </section>
      </CardContent>
    </CardSecondary>
  );
};

module.exports = { UserAddressCard };
